/* Afkar Plus - category wheel: select / drag / auto-advance (BeyondADS 23 Sep 2026) */
(function () {
  'use strict';
  function init(root) {
    if (root.__aw) return; root.__aw = true;
    var labs = Array.prototype.slice.call(root.querySelectorAll('[data-aw-lab]'));
    var ticks = Array.prototype.slice.call(root.querySelectorAll('[data-aw-tick]'));
    var layers = root.querySelectorAll('[data-aw-layer]');
    var arcBox = root.querySelector('.aw-arc');
    var photo = root.querySelector('[data-aw-photo]');
    var prevImg = root.querySelector('[data-aw-prev-img]'), nextImg = root.querySelector('[data-aw-next-img]');
    var explore = root.querySelector('[data-aw-explore]'), exploreLabel = root.querySelector('[data-aw-explore-label]');
    var stage = root.querySelector('[data-aw-stage]'), row = root.querySelector('[data-aw-labs]');
    var sides = root.querySelectorAll('[data-aw-side]'), curN = root.querySelector('[data-aw-cur-n]'), curT = root.querySelector('[data-aw-cur-t]');
    var n = labs.length; if (!n) return;
    var cur = 0, turn = -110, front = 0, quietUntil = 0;
    function bg(el, url) { if (el) el.style.backgroundImage = url ? 'url("' + url + '")' : 'none'; }
    labs.forEach(function (l) { [l.dataset.img, l.dataset.sideA, l.dataset.sideB].forEach(function (u) { if (u) { var im = new Image(); im.src = u; } }); });

    function show(i, instant) {
      i = ((i % n) + n) % n;
      var step = i - cur; if (step > n / 2) step -= n; if (step < -n / 2) step += n;
      turn += step * 45; cur = i;
      var lab = labs[i];
      labs.forEach(function (l, k) { l.classList.toggle('is-on', k === i); l.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      ticks.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (arcBox) arcBox.style.transform = 'rotate(' + turn + 'deg)';
      var nextLayer = instant ? layers[front] : layers[1 - front];
      bg(nextLayer, lab.dataset.img);
      if (!instant) { layers[front].classList.remove('is-on'); nextLayer.classList.add('is-on'); front = 1 - front; }
      else { nextLayer.classList.add('is-on'); }
      bg(prevImg, lab.dataset.sideA || lab.dataset.imgSm);
      bg(nextImg, lab.dataset.sideB || lab.dataset.imgSm);
      Array.prototype.forEach.call(sides, function (a) { a.setAttribute('href', lab.dataset.url); a.setAttribute('aria-label', lab.dataset.label || ''); });
      if (curN) curN.textContent = lab.dataset.num || ''; if (curT) curT.textContent = lab.dataset.label || '';
      var name = lab.dataset.label || '';
      if (exploreLabel) exploreLabel.textContent = name.toLowerCase();
      if (explore) explore.setAttribute('href', lab.dataset.url);
      if (photo) { photo.setAttribute('href', lab.dataset.url); photo.setAttribute('aria-label', name); }
      if (row && getComputedStyle(row).display === 'flex') {
        var left = lab.offsetLeft - (row.clientWidth - lab.offsetWidth) / 2;
        row.scrollTo({ left: Math.max(0, left), behavior: instant ? 'auto' : 'smooth' });
      }
    }
    function touch() { quietUntil = Date.now() + 9000; }

    /* hover or click a label selects it (click on the active one follows the link) */
    labs.forEach(function (l, k) {
      l.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches && k !== cur) { touch(); show(k); } });
      l.addEventListener('click', function (e) { if (k !== cur) { e.preventDefault(); touch(); show(k); } });
    });
    root.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('[data-aw-step]'); if (!s) return;
      e.preventDefault(); touch(); show(cur + parseInt(s.getAttribute('data-aw-step'), 10));
    });

    /* drag / swipe the stage: every 70 px moves one category */
    var sx = null, moved = false;
    function down(x) { sx = x; moved = false; }
    function move(x) {
      if (sx === null) return;
      var dx = x - sx;
      if (Math.abs(dx) > 70) { moved = true; touch(); show(cur + (dx < 0 ? 1 : -1)); sx = x; stage.classList.add('is-dragging'); }
    }
    function up() { sx = null; stage.classList.remove('is-dragging'); }
    stage.addEventListener('pointerdown', function (e) { if (e.button !== 0) return; down(e.clientX); });
    window.addEventListener('pointermove', function (e) { move(e.clientX); });
    window.addEventListener('pointerup', up); window.addEventListener('pointercancel', up);
    stage.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* keyboard */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { touch(); show(cur + 1); } else if (e.key === 'ArrowLeft') { touch(); show(cur - 1); }
    });

    /* gentle auto-advance while on screen */
    setInterval(function () {
      if (document.hidden || Date.now() < quietUntil) return;
      var r = root.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
      show(cur + 1);
    }, 4500);

    show(0, true);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-aw]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
